module.exports = __webpack_public_path__ + "img/s1.fd689b2e.png";